import { getAccessToken } from './authStorage';

export class HttpError extends Error {
  status: number;
  detail: string;
  constructor(status: number, detail: string) {
    super(`${status}: ${detail}`);
    this.status = status;
    this.detail = detail;
  }
}

export async function http<T>(
  url: string,
  init: RequestInit = {},
  attachAuth = true
): Promise<T> {
  const headers = new Headers(init.headers);
  if (attachAuth) {
    const token = getAccessToken();
    if (token) headers.set('Authorization', `Bearer ${token}`);
  }
  if (init.body && !(init.body instanceof FormData) && !headers.has('Content-Type')) {
    headers.set('Content-Type', 'application/json');
  }
  const res = await fetch(url, { ...init, headers });
  if (!res.ok) {
    let detail = res.statusText;
    try {
      const body = await res.text();
      detail = body || detail;
    } catch {
      // ignore
    }
    throw new HttpError(res.status, detail.slice(0, 400));
  }
  if (res.status === 204) return undefined as T;
  return (await res.json()) as T;
}
